<!-- 
Contents of the SUMMARY tab of the provider page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="listing-providers"
      user-guide-section="summary"
      module="providers"
      nav-url="/providers/:id/summary"
    />
    <tabs :provider-id="providerId" :incomplete-contacts="incompleteContacts">
      <provider-summary-panel :provider-id="providerId"/>
    </tabs>
  </div>
</template>

<script>
import providerMixins from "./mixins";
import Tabs from "./Tabs.vue";
import ProviderSummaryPanel from "@/components/providers/ProviderSummaryPanel.vue";

export default {
  name: "ProviderSummary",
  components: { ProviderSummaryPanel, Tabs },
  mixins: [providerMixins]
};
</script>
